// Обработка отправки сообщений в поддержку
window.Tickets = (function () {

    const selectors = {
        ticketsText: ".j-ticket-text",
        ticketsSubmitButton: ".j-ticket-submit",
    };

    const disabledClass = 'm-disabled';

    // Деактивируем кнопку "Отправить", если ввод пуст
    $(document).on('input', selectors.ticketsText, function () {
        const textLength = $.trim($(this).val()).length;
        $(selectors.ticketsSubmitButton).toggleClass(disabledClass, textLength === 0);
    });
    const clear = function () {
        $(selectors.ticketsText).val('');
        $(selectors.ticketsText).trigger('input');
    }

    return {
        clear
    };
}());